/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from './change-password-page.component';
import * as import6 from '../../inputs/form/form.component.ngfactory';
import * as import7 from '../../inputs/form/form.component';
import * as import8 from '../../notification/notification.service';
import * as import9 from '../../inputs/password-field/password-field.component.ngfactory';
import * as import10 from '@angular/forms';
import * as import11 from '../../inputs/password-field/password-field.component';
import * as import12 from '../../buttons/button/button.component.ngfactory';
import * as import13 from '../../buttons/button/button.component';
import * as import14 from '../../orchestration/session.model';
import * as import15 from '../../orchestration/responsive.service';
import * as import16 from '../../page-layout/page-footer-control.directive';
import * as import17 from '../identity-change-password.service';
import * as import18 from '@fedelta-pos/data-client/http/jwt-http-client.service';
import * as import19 from '@fedelta-pos/data-client/configuration/configuration.service';
import * as import20 from '@fedelta-pos/data-client/resource/resource.module';
import * as import21 from '../identity.model';
const styles_ChangePasswordPageComponent:any[] = ([] as any[]);
export const RenderType_ChangePasswordPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ChangePasswordPageComponent,
  data: {}
}
);
export function View_ChangePasswordPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    import0.ɵqud(402653184,2,{form: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),40,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
      ,{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵqud(603979776,3,{contentMessages: 1}),
    import0.ɵqud(603979776,4,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,29,'woa-form',([] as any[]),(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.ChangePasswordPageComponent = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.changePassword()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_FormComponent_0,import6.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import7.FormComponent,[import8.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,5,{models: 1}),
    import0.ɵqud(603979776,6,{modelContainers: 1}),
    import0.ɵprd(5120,(null as any),import7.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import7.FormComponent]),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,0,'input',([] as any[]),[
      [
        8,
        'hidden',
        0
      ]
      ,
      [
        8,
        'value',
        0
      ]
      ,
      [
        1,
        'autocomplete',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,9,'woa-password-field',[
      [
        'name',
        'oldPassword'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'minlength',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.ChangePasswordPageComponent = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.oldPassword = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_PasswordFieldComponent_0,import9.RenderType_PasswordFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import10.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import10.MinLengthValidator,([] as any[]),{minlength: [
        0,
        'minlength'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import10.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import10.NG_VALIDATORS,(p0_0:any,p1_0:any,p2_0:any) => {
      return [
        p0_0,
        p1_0,
        p2_0
      ]
      ;
    },[
      import10.RequiredValidator,
      import10.MinLengthValidator,
      import10.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import11.PasswordFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import10.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import11.PasswordFieldComponent]),
      import0.ɵdid(671744,[[
        5,
        4
      ]
    ],0,import10.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import10.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import10.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import10.NgControl,(null as any),[import10.NgModel]),
    import0.ɵdid(16384,(null as any),0,import10.NgControlStatus,[import10.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,9,'woa-password-field',[
      [
        'name',
        'newPassword'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'minlength',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.ChangePasswordPageComponent = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.newPassword = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_PasswordFieldComponent_0,import9.RenderType_PasswordFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import10.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import10.MinLengthValidator,([] as any[]),{minlength: [
        0,
        'minlength'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import10.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import10.NG_VALIDATORS,(p0_0:any,p1_0:any,p2_0:any) => {
      return [
        p0_0,
        p1_0,
        p2_0
      ]
      ;
    },[
      import10.RequiredValidator,
      import10.MinLengthValidator,
      import10.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import11.PasswordFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import10.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import11.PasswordFieldComponent]),
      import0.ɵdid(671744,[[
        5,
        4
      ]
    ],0,import10.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import10.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import10.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import10.NgControl,(null as any),[import10.NgModel]),
    import0.ɵdid(16384,(null as any),0,import10.NgControlStatus,[import10.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),7,2,'woa-button',[
      [
        'id',
        'button-change-password'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.ChangePasswordPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,40).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import12.View_ButtonComponent_0,import12.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import13.ButtonComponent,[
      import0.ElementRef,
      import14.SessionModel,
      import0.ChangeDetectorRef,
      import15.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import16.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.ChangePasswordPageComponent = v.component;
    const currVal_0:any = 'woa.heading.change-password.title';
    ck(v,3,0,currVal_0);
    const currVal_14:any = '';
    ck(v,17,0,currVal_14);
    const currVal_15:any = '8';
    ck(v,18,0,currVal_15);
    const currVal_16:any = '20';
    ck(v,19,0,currVal_16);
    const currVal_17:any = 'woa.label.change-password.currentPassword';
    const currVal_18:any = 'current-password';
    const currVal_19:any = '20';
    ck(v,21,0,currVal_17,currVal_18,currVal_19);
    const currVal_20:any = 'oldPassword';
    const currVal_21:any = co.oldPassword;
    ck(v,23,0,currVal_20,currVal_21);
    const currVal_32:any = '';
    ck(v,28,0,currVal_32);
    const currVal_33:any = '8';
    ck(v,29,0,currVal_33);
    const currVal_34:any = '20';
    ck(v,30,0,currVal_34);
    const currVal_35:any = 'woa.label.change-password.newPassword';
    const currVal_36:any = 'new-password';
    const currVal_37:any = '20';
    ck(v,32,0,currVal_35,currVal_36,currVal_37);
    const currVal_38:any = 'newPassword';
    const currVal_39:any = co.newPassword;
    ck(v,34,0,currVal_38,currVal_39);
    const currVal_67:any = 'woa.button.change-password.changePassword';
    ck(v,40,0,currVal_67);
  },(ck,v) => {
    var co:import5.ChangePasswordPageComponent = v.component;
    const currVal_1:any = true;
    const currVal_2:any = co.identityModel.loginIdentity;
    const currVal_3:any = 'username';
    ck(v,14,0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = (import0.ɵnov(v,17).required? '': (null as any));
    const currVal_5:any = (import0.ɵnov(v,18).minlength? import0.ɵnov(v,18).minlength: (null as any));
    const currVal_6:any = (import0.ɵnov(v,19).maxlength? import0.ɵnov(v,19).maxlength: (null as any));
    const currVal_7:any = import0.ɵnov(v,25).ngClassUntouched;
    const currVal_8:any = import0.ɵnov(v,25).ngClassTouched;
    const currVal_9:any = import0.ɵnov(v,25).ngClassPristine;
    const currVal_10:any = import0.ɵnov(v,25).ngClassDirty;
    const currVal_11:any = import0.ɵnov(v,25).ngClassValid;
    const currVal_12:any = import0.ɵnov(v,25).ngClassInvalid;
    const currVal_13:any = import0.ɵnov(v,25).ngClassPending;
    ck(v,16,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13);
    const currVal_22:any = (import0.ɵnov(v,28).required? '': (null as any));
    const currVal_23:any = (import0.ɵnov(v,29).minlength? import0.ɵnov(v,29).minlength: (null as any));
    const currVal_24:any = (import0.ɵnov(v,30).maxlength? import0.ɵnov(v,30).maxlength: (null as any));
    const currVal_25:any = import0.ɵnov(v,36).ngClassUntouched;
    const currVal_26:any = import0.ɵnov(v,36).ngClassTouched;
    const currVal_27:any = import0.ɵnov(v,36).ngClassPristine;
    const currVal_28:any = import0.ɵnov(v,36).ngClassDirty;
    const currVal_29:any = import0.ɵnov(v,36).ngClassValid;
    const currVal_30:any = import0.ɵnov(v,36).ngClassInvalid;
    const currVal_31:any = import0.ɵnov(v,36).ngClassPending;
    ck(v,27,0,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31);
    const currVal_40:any = import0.ɵnov(v,40).overrideFlatBackgroundColor;
    const currVal_41:any = import0.ɵnov(v,40).overrideFlatForegroundColor;
    const currVal_42:any = import0.ɵnov(v,40).overrideOutlineBackgroundColor;
    const currVal_43:any = import0.ɵnov(v,40).overrideOutlineForegroundColor;
    const currVal_44:any = import0.ɵnov(v,40).overrideOutlineBorderColor;
    const currVal_45:any = import0.ɵnov(v,40).overrideRaisedBackgroundColor;
    const currVal_46:any = import0.ɵnov(v,40).overrideRaisedForegroundColor;
    const currVal_47:any = import0.ɵnov(v,40).disabled;
    const currVal_48:any = import0.ɵnov(v,40).invisible;
    const currVal_49:any = import0.ɵnov(v,40).hovered;
    const currVal_50:any = import0.ɵnov(v,40).native;
    const currVal_51:any = import0.ɵnov(v,40).button;
    const currVal_52:any = import0.ɵnov(v,40).firstTier;
    const currVal_53:any = import0.ɵnov(v,40).secondTier;
    const currVal_54:any = import0.ɵnov(v,40).highProminence;
    const currVal_55:any = import0.ɵnov(v,40).lowProminence;
    const currVal_56:any = import0.ɵnov(v,40).affirmativeConnotation;
    const currVal_57:any = import0.ɵnov(v,40).dissuasiveConnotation;
    const currVal_58:any = import0.ɵnov(v,40).negativeConnotation;
    const currVal_59:any = import0.ɵnov(v,40).squareShape;
    const currVal_60:any = import0.ɵnov(v,40).roundedShape;
    const currVal_61:any = import0.ɵnov(v,40).ovalShape;
    const currVal_62:any = import0.ɵnov(v,40).flatStyle;
    const currVal_63:any = import0.ɵnov(v,40).outlineStyle;
    const currVal_64:any = import0.ɵnov(v,40).raisedStyle;
    const currVal_65:any = import0.ɵnov(v,40).verticalLayout;
    const currVal_66:any = import0.ɵnov(v,40).horizontalLayout;
    ck(v,39,1,[
      currVal_40,
      currVal_41,
      currVal_42,
      currVal_43,
      currVal_44,
      currVal_45,
      currVal_46,
      currVal_47,
      currVal_48,
      currVal_49,
      currVal_50,
      currVal_51,
      currVal_52,
      currVal_53,
      currVal_54,
      currVal_55,
      currVal_56,
      currVal_57,
      currVal_58,
      currVal_59,
      currVal_60,
      currVal_61,
      currVal_62,
      currVal_63,
      currVal_64,
      currVal_65,
      currVal_66
    ]
    );
  });
}
function View_ChangePasswordPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-change-password-page',([] as any[]),(null as any),(null as any),(null as any),View_ChangePasswordPageComponent_0,RenderType_ChangePasswordPageComponent)),
    import0.ɵprd(512,(null as any),import17.IdentityChangePasswordService,import17.IdentityChangePasswordService,[
      import18.JwtHttpClientService,
      import19.ConfigurationService,
      import20.ResourceModule.RESOURCE_NAMESPACE_KEY,
      import20.ResourceModule.ACTION_NAMES_KEY
    ]
    ),
    import0.ɵdid(49152,(null as any),0,import5.ChangePasswordPageComponent,[
      import8.NotificationService,
      import4.NavigationService,
      import17.IdentityChangePasswordService,
      import21.IdentityModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import5.ChangePasswordPageComponent])
  ]
  ,(null as any),(null as any));
}
export const ChangePasswordPageComponentNgFactory:import0.ComponentFactory<import5.ChangePasswordPageComponent> = import0.ɵccf('woa-change-password-page',import5.ChangePasswordPageComponent,View_ChangePasswordPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/identity/change-password-page/change-password-page.component.ngfactory.ts